<template>
<div class="sections-container">
    <div class="header-sections">
      <span class="title-section">Colaboradores</span>
      <div class="filter-colum-sections">
          <v-text-field
            style="width: 320px;"
            type="text"
            placeholder="Buscar"
            v-model="currentSearch"
            color="#222222"
            clearable
            @click:clear="clearSearch"
            variant="underlined">
            <template v-slot:append-inner>
              <v-icon color="#222222" icon="mdi-magnify" size="small"/>
            </template>
          </v-text-field>
      </div>
    </div>
    <div class="select-filter-container">
      <div></div>
      <div class="autocomplete-container">
        <span class="title-filter">Rol:</span>
        <v-select
          v-model="filterSelected"
          :items="filterData"
          item-title="label"
          item-value="value"
          density="compact"
          hide-details="auto"
          variant="solo"
          class="no-bg"/>
      </div>

    </div>
    <div class="container-content-section">
      <collaborator-card v-for="item in filter" :key="item._id"
        :collaborator="item" @refreshList="getCollaborators"/>
    </div>

    <div class="fab-button" @click="addModal">
      <v-icon icon="mdi-plus"></v-icon>
    </div>

    <add-edit-collaborators
    ref="addEditModal"
    @refreshList="getCollaborators"/>
</div>
</template>

<script>
import CollaboratorCard from '../cards/CollaboratorCard.vue'
import AddEditCollaborators from '../forms/AddEditCollaborators.vue'
import collaboratorsApi from '@/api/collaboratorsApi'
export default {
  name: 'CommerciaVueCollaborators',
  components: {
    CollaboratorCard,
    AddEditCollaborators
  },
  data () {
    return {
      collaborators: [],
      filter: [],
      currentSearch: '',
      filterSelected: 'Todos',
      filterData: ['Todos', 'Administrador', 'Cajero', 'Cliente', 'Manager', 'Finanzas']
    }
  },
  computed: {
    busines () {
      return this.$store.getters.business
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user?.role === 'finance' || this.user?.role === 'manager') {
      this.$router.push({ name: 'dashboard' })
    }
    this.getCollaborators()
  },
  watch: {
    currentSearch (newVal, oldVal) {
      this.getCollaborators()
    },
    filterSelected (newVal, oldVal) {
      this.getDataFilter()
    }
  },
  methods: {
    clearSearch () {
      this.currentSearch = ''
      this.getCollaborators()
    },
    addModal () {
      this.$refs.addEditModal.add()
    },
    async getCollaborators () {
      this.collaborators = await collaboratorsApi.list(this.busines._id, this.currentSearch)
      this.getDataFilter()
    },
    getDataFilter () {
      this.filter = []
      if (this.filterSelected === 'Todos') {
        this.filter = this.collaborators
      } else {
        for (const item of this.collaborators) {
          console.log(item.role.description)
          console.log(this.filterSelected)
          if (item.role.description === (this.filterSelected)) {
            this.filter.push(item)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/sections.css';
  @import '@/assets/styles/inputs.css';
</style>
